
import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';

const NegavidPlayerComponent = (props) => {



    useEffect(() => {
        setTimeout(() => {
            window.message = ["name", "family", "email", "phone", "#fff", "5"];
        }, 1000); // زمان به میلی‌ثانیه افزوده شده است
    }, []);

    // useEffect(() => {
    //     const script = document.createElement('script');
    //     script.src = "https://negavid.com/uploads/native/dynamic-watermark/latest/negavid-dynamic-watermark-production-second.js?v=1";
    //     script.async = true;
    //     document.head.appendChild(script);
    //
    //     return () => {
    //         // از اسکریپت پاکسازی کنید در صورت نیاز
    //         document.head.removeChild(script);
    //     };
    // }, []);

    return (

        <div>

            {/*<Helmet>*/}
            {/*    <title>عنوان صفحه</title>*/}
            {/*</Helmet>*/}

            <div className="negavid-video-stream" style={{position: 'relative', paddingBottom: '56.25%', paddingTop: '25px', height: 0, overflow: 'hidden'}}> <iframe id={String(props.id_video)} style={{border: 'none', position: 'absolute', top: 0, left: 0, width: '100%', height: '100%'}} src={"https://open.negavid.com/stream/video/embed/code/" + String(props.id_video) } allowFullScreen="true" webkitallowfullscreen="true" mozallowfullscreen="true" /></div>
        </div>

    );
};

export default NegavidPlayerComponent;